import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogComponent } from './blog.component';
import { RouterModule, Routes } from '@angular/router';
import { BlogItemComponent } from './blog-item/blog-item.component';
import { BlogContentComponent } from './blog-content/blog-content.component';
import { BlogRoutingModule } from './blog-rounting.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

const routes:Routes = [
  {
    path:'',
    component: BlogComponent
  },
  {
    path:':id',
    component: BlogContentComponent
  }
]

@NgModule({
  declarations: [
    BlogComponent,
    BlogItemComponent,
    BlogContentComponent],
  imports: [
    CommonModule,
    BlogRoutingModule,
    FormsModule,
    TranslateModule.forChild()
  ],
  exports: [
    BlogComponent,
    BlogItemComponent,
    BlogContentComponent
  ]
})
export class BlogModule { }
